import type { BoxProps } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'
import React from 'react'
import { useParams } from 'react-router-dom'

import { NotFoundPage } from '../../404'
import Allianz from './Allianz'
import Colonnade from './Colonnade'
import CPP from './CPP'
import GCP from './GCP'
import Koop from './Koop'
import Uniqa from './Uniqa'

export const Insurer = () => {
  const { insurerId } = useParams()

  let component: React.ReactNode
  switch (insurerId) {
    case '3':
      component = <Allianz />
      break
    case '16':
      component = <Colonnade />
      break
    case '5':
      component = <CPP />
      break
    case '6':
      component = <GCP />
      break
    case '2':
      component = <Koop />
      break
    case '1':
      component = <Uniqa />
      break
    default: component = <NotFoundPage />
  }

  return (
    <>
      {component}
    </>
  )
}

export const ContentLabel = ({ label, sx, ...rest }: { label: string | React.ReactNode } & BoxProps) => {
  return (
    <Box
      sx={{
        fontSize: 'xl',
        fontWeight: 'bold',
        mt: 3,
        ...sx
      }}
      {...rest}
    >
      {label}
    </Box >
  )
}